<p-tabs
  [(value)]="selectedMainTabIndex"
  (valueChange)="onMainTabChange($event)"
>
  <p-tablist>
    <p-tab [value]="0">Issuer</p-tab>
    <p-tab [value]="1">Insider</p-tab>
    <p-tab [value]="2">Security</p-tab>
    <p-tab [value]="3">Insider Relationship</p-tab>
  </p-tablist>

  <p-tabpanels>
    <p-tabpanel [value]="0">
      <ng-container *ngIf="selectedMainTabIndex === 0">
        <app-issuer [isActive]="true"></app-issuer>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <ng-container *ngIf="selectedMainTabIndex === 1">
        <app-insider [isActive]="true"></app-insider>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="2">
      <ng-container *ngIf="selectedMainTabIndex === 2">
        <app-security [isActive]="true"></app-security>
      </ng-container>
    </p-tabpanel>

    <p-tabpanel [value]="3">
      <ng-container *ngIf="selectedMainTabIndex === 3">
        <app-insider-relationship [isActive]="true"></app-insider-relationship>
      </ng-container>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
